// src/components/MoodGate.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "../utils/api";

export default function MoodGate({ children }) {
  const [state, setState] = useState({ loading: true, allow: false });

  useEffect(() => {
    (async () => {
      try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Chicago";
        const token = localStorage.getItem("authToken");
        if (!token) return setState({ loading: false, allow: false });
        const { data } = await api.get("/api/mood/status/", {
          params: { tz },
          headers: { Authorization: `Token ${token}` },
        });
        const allow = !!data?.has_today;
        setState({ loading: false, allow });
      } catch {
        setState({ loading: false, allow: false });
      }
    })();
  }, []);

  if (state.loading) return null;           // or a nice spinner
  if (!state.allow) return <Navigate to="/moodcall" replace />;

  return children;
}
